import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IFoMonAnChiTietActionTypes } from "../../action-types/thuc-don/IFoMonAnChiTietActionTypes";
import { IFoMonAnChiTietReducer } from "../../page-state-model/thuc-don/IFoMonAnChiTietReducer";
const iniState: IFoMonAnChiTietReducer = {
    status: ePageBaseStatus.is_not_initialization,
    foMonAnChiTiets: []
}
export const foMonAnChiTietReducer = (state: IFoMonAnChiTietReducer = iniState, action: IFoMonAnChiTietActionTypes): IFoMonAnChiTietReducer => {
    switch (action.type) {
        case "MON_AN_CHI_TIET_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "MON_AN_CHI_TIET_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foMonAnChiTiets: action.payload
            }
        case "MON_AN_CHI_TIET_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foMonAnChiTiets: []
            }
        case "MON_AN_CHI_TIET_LOAD_COSO_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "MON_AN_CHI_TIET_LOAD_COSO_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foMonAnChiTiets: action.payload
            }
        case "MON_AN_CHI_TIET_LOAD_COSO_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foMonAnChiTiets: []
            }
        case "MON_AN_CHI_TIET_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "MON_AN_CHI_TIET_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "MON_AN_CHI_TIET_SHOW_IMPORT_MODAL":
            return {
                ...state,
                isShowImportModal: true
            }
        case "MON_AN_CHI_TIET_CLOSE_IMPORT_MODAL":
            return {
                ...state,
                isShowImportModal: false,
            }
        case "MON_AN_CHI_TIET_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "MON_AN_CHI_TIET_SAVE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "MON_AN_CHI_TIET_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "MON_AN_CHI_TIET_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "MON_AN_CHI_TIET_DELETE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "MON_AN_CHI_TIET_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}